module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_weekendsale_bg-35c071bb14bd1adda47895dc1ac09365.jpg";